import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import { HHIEButton } from "../utility/HHIEButton";
import { HHIELinkBtn } from "../utility/HHIELinkBtn";
import Loading from "../utility/Loading";

export const ResetExpiredTemporaryPassword = () => {
    const [loading, setLoading] = useState(false);
    const [pageIsValid, setValid] = useState();
    const [pocUserId, setPocUserId] = useState();
    const [pageResetId, setId] = useState();
    const [success, setSuccess] = useState(false);
    const [failure, setFailure] = useState(false);

    useEffect(()=> {
        const RunUseEffect = async (pageResetId) => {
            setLoading(true);
            const resultForValid = await CheckIfPageIsValid(pageResetId); 
            setValid(resultForValid);
            setId(pageResetId);
            const userId = await RetrieveUserId(pageResetId);
            setPocUserId(userId);
            setLoading(false);
        }
        RunUseEffect(window.location.search.substring(1).split("=")[1]);
    }, []);

    const CheckIfPageIsValid = async (argument) => {
        var isValid = false;
        if (argument !== undefined) {
            if (argument !== null) {
                if (argument.length === 50) {
                    const backendResult = await fetch('api/etpn/isValid/' + argument)
                        .then(async (response) => {
                            try {
                                return await response.json()
                                    .then(json => {
                                        if (json.errors !== null && json.errors !== "") alert(json.errors);
                                        return json.message;
                                    });
                            }
                            catch(ex) {
                                console.log("IsValidCheck Json Exception:", ex);
                            }
                        })
                        .catch(ex => {
                            console.log("IsValidCheck Response Exception:", ex);
                        });
                    isValid = backendResult;
                }
            }
        }
        return isValid;
    }
    const RetrieveUserId = async (argument) => {
        var userId = "";
        const backendUserId = await fetch('api/etpn/retrievePocUserUserId/' + argument)
            .then(async (response) => {
                if (response.status === 204) {
                    return null;
                }
                try {
                    return await response.json()
                        .then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors);
                            return json.message;
                        });
                }
                catch(ex) {
                    console.log("RetrieveUserId Json Exception:", ex);
                    return null;
                }
            })
            .catch(ex => {
                console.log("RetrieveUserId Response Exception:", ex);
                return null;
            });
        userId = backendUserId;
        return userId;
    }

    const handleClick = async () => {
        const id = pageResetId;
        if (id === undefined || id === null || id === "") {
            setFailure(true);
        }
        const backendResult = await fetch('api/etpn/reset-temp-pwd-by-etpn/' + pageResetId)
        .then(async (response) => {
            try {
                return await response.json()
                    .then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors);
                        return json.message;
                    });
            }
            catch(ex) {
                console.log("handleClick Json Exception:", ex);
            }
        })
        .catch(ex => {
            console.log("handleClick Response Exception:", ex);
        });
        setSuccess(backendResult);
        setFailure(!backendResult);
        setTimeout(() => {
            if (backendResult) { 
                setValid(false);
            }
            window.location.href="/login";
        }, 10000);
    }

    return (
    <>
        {loading && <Loading message="Loading. . ."/>}
        {failure && <Alert variant="danger">Failure. Contact the HHIE.</Alert>}
        {success && <Alert variant="success">Success, password has been reset to a temporary password.</Alert>}
        {!loading && (!success && !failure) &&
        <div>
            {(pageIsValid && pocUserId) &&
                <div 
                    className="home-container" 
                    style={{
                        position: 'absolute', 
                        left: '50%', 
                        top: '50%',
                        transform: 'translate(-50%, -60%)'
                        ,maxWidth:'850px'
                    }}
                >
                    <h2>Reset {pocUserId}'s Temporary Password</h2>
                    <br/>
                    <div>
                        Aloha, <br/><br/> This page allows you as an HHIE Staff Member to reset <em>{pocUserId}'s</em> temporary password.<br/><br/> If this user is expected to be able to login, please reset the password by clicking the button below.
                    </div>
                    <br/>
                    <div>
                        <HHIEButton 
                            title="Reset Password" 
                            size="sm"
                            onClick={handleClick}
                        />
                    </div> 
                </div>
                }
                {!pageIsValid &&
                    <Alert variant="danger">
                    This page is not supported. <HHIELinkBtn onClick={() => {window.location.href = "/login";}} name="Log In"/>
                    <hr/>
                    If you needed to reset someone's temporary password, you will have to do it manually.<br/>
                    <ul>
                        <li>Log In using the 'HHIE Staff' link button</li>
                        <li>Navigate to the tab 'Organizations'</li>
                        <li>Search for the Organization where the POC who's temporary password has expired is enrolled in. Click that organization.</li>
                        <li>Scroll down to the 'Points of Contact' section</li>
                        <li>Click 'Reset Password' by the correct POC.</li>
                    </ul>
                    This will reset the POC's temporary password.
                    <hr/>
                    Contact helpdesk@hawaiihie.org via email or call (808) 441-1374 for assistance.
                </Alert>}
            
        </div>}
    </>);
}